<template lang='pug' src='./form-virtual.pug'></template>

<script>
import api from 'api'
import axios from 'axios'
import { closeModal } from '@/methods'

export default {
  data: () => {
    return {
      fullname: '',
      phone: '',
      email: '',
      message: '',
      whichPractice: '',
      postUrl: api + '/rg-mail/v1/virtual',
      formSubmitted: false
    }
  },
  mixins: [closeModal],
  methods: {
    validate () {
      this.$validator.validateAll()
      .then(result => {
        if (result) {
          this.onSubmit()
        }
      })
      .catch((e) => {
        console.error(e)
      })
    },
    onSubmit () {
      this.formSubmitted = true
      if (this.$route.path === '/virtual-orthodontic-consultation') {
        this.whichPractice = 'Virtual'
      }
      if (this.$route.path === '/free-orthodontic-consultation') {
        this.whichPractice = 'Orthodontics'
      }
      if (this.$route.path === '/pediatric-appointment') {
        this.whichPractice = 'Pediatric'
      }
      axios.post(this.postUrl, {
        fullname: this.fullname,
        phone: this.phone,
        email: this.email,
        message: this.message,
        whichPractice: this.whichPractice
      })
      .then(res => {
        this.formSubmitted = false
        this.$store.dispatch('FORM_SUCCESS', true)

        this.fullname = ''
        this.phone = ''
        this.email = ''
        this.message = ''
        this.whichPractice = ''
        if (this.$route.path === '/virtual-orthodontic-consultation') {
          this.$router.push('/thank-you-virtual')
        }
        if (this.$route.path === '/free-orthodontic-consultation') {
          this.$router.push('/thank-you-consultation')
        }
        if (this.$route.path === '/pediatric-appointment') {
          this.$router.push('/thank-you-appointment')
        }
      })
      .catch(e => { console.error(e) })
    }
  }
}
</script>



// WEBPACK FOOTER //
// form-virtual.vue?f32c0354